import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'itpx-catalog',
  templateUrl: './catalog.component.html',
  styleUrls: ['./catalog.component.css']
})
export class CatalogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/catalog/catalog.component.ts